export const COUNTRIES_REQUESTED = 'COUNTRIES_REQUESTED'
export const COUNTRIES_RECEIVED = 'COUNTRIES_RECEIVED'
